import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * State for the release notes store.
 */
export interface ReleaseNotesState {
  /**
   * The last seen release version by the user.
   */
  seenVersion: string | null;
}

/**
 * Actions for the release notes store.
 */
export interface ReleaseNotesActions {
  /**
   * Set the last seen release version.
   */
  setSeenVersion: (version: string) => void;
}

/**
 * Zustand store for managing release notes popup state.
 * Persists seenVersion in localStorage.
 */
export const useReleaseNotesStore = create<ReleaseNotesState & ReleaseNotesActions>()(
  persist(
    (set) => ({
      seenVersion: null,
      setSeenVersion: (version: string) => set({ seenVersion: version }),
    }),
    {
      name: 'release-notes-store',
      getStorage: () => localStorage,
    },
  ),
);
